import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.adminBicycleReserve.replace(appPath.admin, ''),
	components: () => [import(/* webpackChunkName: 'adminBicycleReserve' */ './component')],
	render: ([AdminBicycleReserve]) => <AdminBicycleReserve />,
};

export default routes;
